// extracted by mini-css-extract-plugin
export default {"QueueChart":"QueueChartView_QueueChart__rW-Hk"};